import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** DELETE `/srm/misc-purchase-order/{id}`。實體刪除 DRAFT（be doc abbce90d；有付款紀錄時拒絕）。body：updatedAt。 */
export async function cancelDraftMiscPurchaseOrder(id, payload = {}) {
  const { data: raw } = await request.delete(
    `/srm/misc-purchase-order/${id}`,
    { data: keysToSnake(payload) },
  );
  return parseVer4DetailResponse(raw);
}
